module.exports = __webpack_public_path__ + "static/media/icon-drop-up.056dde4a.svg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/icon-drop-up.svg
// module id = 113
// module chunks = 0 1 2